import axios from "axios";
import store from "../stores/store";

const restApi = axios.create({
	// TODO: Caso habilitado o cors
	// headers: {
	// 	"Access-Control-Allow-Origin": "*",
	// 	"Content-Type": "application/json",
	// 	"Access-Control-Allow-Credentials": true,
	// },
	//crossDomain: true,
});

restApi.interceptors.request.use(async (config) => {
	if (!config.url.toLowerCase().includes("session")) {
		const token = store.getState().auth.token;

		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
	}
	return config;
});

// Interceptor de resposta para tratar erros de autorização
restApi.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    if (error.response && error.response.status === 401) {
	  reStartSession();
    }
    return Promise.reject(error);
  }
);

const reStartSession = async () => {
	try {
		const basePath = `${process.env.REACT_APP_API_BASE_URL}/store`;
		const formData = new FormData();
		formData.append("email", process.env.REACT_APP_API_SESSION_USER);

		const headers = {
			"Content-Type": "multipart/form-data",
		};

		const url = `${basePath}/session`;

		const response = await restApi.post(url, formData, { headers });

		if (response.data?.token) {
			store.dispatch({
				type: "SET_TOKEN",
				payload: response.data?.token,
			});
		} else {
			throw new Error("Token not found");
		}
	} catch (error) {
		console.error("authService.session", "Error creating session", error);
		throw new Error("Error creating session", error);
	}
};

export default restApi;